import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  tableOptionsContainer: {
    position: 'relative',
    marginBottom: 70,

    [theme.breakpoints.down('md')]: {
      marginBottom: 100,
    },
  },
  unavailable: {
    display: 'flex',
    cursor: 'pointer',
    '& span.material-icons': {
      fontSize: '0.875rem',
      color: theme.palette.grey[700],
      fontWeight: 400,
      margin: 2,
    },
  },
}));
